import { configureStore } from '@reduxjs/toolkit';
import commonReducer from '@/redux/common/commonSlice';

export const store = configureStore({
  reducer: {
    common: commonReducer
  },
});
